import * as React from 'react';

function SvgComponent({ fill = '#000', stroke = '#161616', ...props }) {
  return (
    <svg
      width="40"
      height="19"
      viewBox="0 0 40 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3 0.5H37C38.3807 0.5 39.5 1.61929 39.5 3V16C39.5 17.3807 38.3807 18.5 37 18.5H3C1.61929 18.5 0.5 17.3807 0.5 16V3C0.5 1.61929 1.61929 0.5 3 0.5Z"
        stroke={stroke}
      />
      <path
        d="M13.895 11.362C13.895 11.728 13.796 12.034 13.598 12.28C13.406 12.52 13.145 12.7 12.815 12.82C12.485 12.94 12.122 13 11.726 13H8.612V6.60999H12.167C12.467 6.60999 12.725 6.69099 12.941 6.85299C13.163 7.00899 13.331 7.21299 13.445 7.46499C13.565 7.71699 13.625 7.97799 13.625 8.24799C13.625 8.54799 13.547 8.83599 13.391 9.11199C13.235 9.38199 13.007 9.58599 12.707 9.72399C13.073 9.83199 13.361 10.024 13.571 10.3C13.787 10.576 13.895 10.93 13.895 11.362ZM12.392 11.065C12.392 10.927 12.365 10.807 12.311 10.705C12.257 10.597 12.185 10.513 12.095 10.453C12.011 10.387 11.909 10.354 11.789 10.354H10.088V11.749H11.726C11.852 11.749 11.963 11.719 12.059 11.659C12.161 11.599 12.242 11.518 12.302 11.416C12.362 11.314 12.392 11.197 12.392 11.065ZM10.088 7.86999V9.19299H11.537C11.645 9.19299 11.744 9.16899 11.834 9.12099C11.93 9.07299 12.008 9.00098 12.068 8.90498C12.128 8.80298 12.158 8.67699 12.158 8.52699C12.158 8.38299 12.131 8.26299 12.077 8.16699C12.029 8.07099 11.963 7.99899 11.879 7.95099C11.795 7.89699 11.699 7.86999 11.591 7.86999H10.088ZM19.7953 11.704V13H15.3043V6.60999H19.7143V7.90599H16.7803V9.14798H19.3003V10.345H16.7803V11.704H19.7953ZM26.101 7.90599H24.157V13H22.681V7.90599H20.728V6.60999H26.101V7.90599ZM28.384 6.60999H29.977L32.173 13H30.661L30.166 11.569H28.177L27.691 13H26.179L28.384 6.60999ZM29.923 10.552L29.176 8.09499L28.411 10.552H29.923Z"
        fill={fill}
      />
    </svg>
  );
}

export default SvgComponent;
